import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

// components
import NumberWidget from "app/static/frontend/widgets/components/NumberWidget"

// selectors
import {
    selectWidgetDataSources,
    selectWidgetDescription,
    selectWidgetFilters,
    selectWidgetKey,
    selectWidgetQuorumDataType,
} from "app/static/frontend/widgets/selectors/selectors"

import {
    selectIsFraction,
    selectIsTransactionSum,
    selectLabels,
    selectNumberWidgetCanLoad,
    selectOperation,
    selectSegueArgs,
} from "app/static/frontend/widgets/selectors/numberWidgetSelectors"

// action creators
import { segueToSearch } from "app/static/frontend/search-new/action-creators"

const mapStateToProps = createStructuredSelector({
    canLoad: selectNumberWidgetCanLoad,
    dataSources: selectWidgetDataSources,
    description: selectWidgetDescription,
    filters: selectWidgetFilters,
    widgetKey: selectWidgetKey,

    // number
    isFraction: selectIsFraction,
    isTransactionSum: selectIsTransactionSum,
    labels: selectLabels,
    operation: selectOperation,
    segueArgs: selectSegueArgs,

    qdt: selectWidgetQuorumDataType,
})

const mapDispatchToProps = { segueToSearch }

export default connect(mapStateToProps, mapDispatchToProps)(NumberWidget)
